/* Zip Code Styling */
.entry {
    width: 100%;
}

.zip {
    width: 90px;
}
